import React, { useEffect } from 'react';
import Icon from '../AppIcon';

const ImprintModal = ({ isOpen, onClose }) => {
  // Handle ESC key
  useEffect(() => {
    const handleEsc = (e) => {
      if (e?.key === 'Escape' && isOpen) {
        onClose();
      }
    };
    window.addEventListener('keydown', handleEsc);
    return () => window.removeEventListener('keydown', handleEsc);
  }, [isOpen, onClose]);

  // Prevent body scroll when modal is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  const handleBackdropClick = (e) => {
    if (e?.target === e?.currentTarget) {
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center animate-fade-in"
      style={{ background: 'rgba(0, 0, 0, 0.6)', backdropFilter: 'blur(4px)' }}
      onClick={handleBackdropClick}
    >
      <div className="relative w-full max-w-2xl mx-4 rounded-xl shadow-lg animate-scale-in max-h-[90vh] overflow-hidden flex flex-col" style={{ background: 'var(--color-card)', border: '1px solid var(--color-border)' }}>
        {/* Close button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 w-8 h-8 flex items-center justify-center rounded-lg transition-colors z-10"
          style={{ background: 'transparent' }}
          onMouseEnter={(e) => e.currentTarget.style.background = 'var(--color-muted)'}
          onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
          aria-label="Close modal"
        >
          <Icon name="X" size={20} color="var(--color-muted-foreground)" />
        </button>

        {/* Header */}
        <div className="p-6 md:p-8 border-b border-border">
          <h2 className="text-2xl font-semibold" style={{ color: 'var(--color-text-primary)', fontFamily: 'IBM Plex Sans', fontWeight: 600 }}>
            Imprint
          </h2>
        </div>

        {/* Scrollable Content */}
        <div className="p-6 md:p-8 overflow-y-auto flex-1">
          <div className="space-y-6 text-sm" style={{ color: 'var(--color-text-secondary)', fontFamily: 'IBM Plex Sans' }}>
            {/* Company Information */}
            <div>
              <h3 className="font-semibold mb-2" style={{ color: 'var(--color-text-primary)' }}>Company Name and Address</h3>
              <p>Sleeve GmbH</p>
              <p>Mariahilfer Straße 101/1/46</p>
              <p>1060 Vienna, Austria</p>
            </div>

            {/* Legal Disclosure */}
            <div>
              <h3 className="font-semibold mb-2" style={{ color: 'var(--color-text-primary)' }}>Legal Disclosure</h3>
              <p>Information in accordance with §25 Media Act</p>
            </div>

            {/* Registration Numbers */}
            <div>
              <h3 className="font-semibold mb-2" style={{ color: 'var(--color-text-primary)' }}>Registration Numbers</h3>
              <p>Company Register Number: FN 123456a</p>
              <p>UID Number: ATU12345678</p>
            </div>

            {/* Contact Details */}
            <div>
              <h3 className="font-semibold mb-2" style={{ color: 'var(--color-text-primary)' }}>Contact Details</h3>
              <p>Email: office@sleeve.tech</p>
              <p>Phone: +43 1 234 5678</p>
            </div>

            {/* Founders */}
            <div>
              <h3 className="font-semibold mb-2" style={{ color: 'var(--color-text-primary)' }}>Managing Directors</h3>
              <p>Maximilian Mustermann</p>
              <p>Anna Beispiel</p>
            </div>

            {/* Court and Chamber Information */}
            <div>
              <h3 className="font-semibold mb-2" style={{ color: 'var(--color-text-primary)' }}>Court and Chamber Information</h3>
              <p>Commercial Court: Handelsgericht Wien</p>
              <p>Chamber: Wirtschaftskammer Wien</p>
            </div>

            {/* Regulatory Authority */}
            <div>
              <h3 className="font-semibold mb-2" style={{ color: 'var(--color-text-primary)' }}>Regulatory Authority</h3>
              <p>Magistrat der Stadt Wien</p>
            </div>

            {/* Disclaimer */}
            <div className="pt-4 border-t border-border">
              <h3 className="font-semibold mb-2" style={{ color: 'var(--color-text-primary)' }}>Disclaimer</h3>
              <p className="leading-relaxed">
                Despite careful content control, we assume no liability for the content of external links. 
                The operators of the linked pages are solely responsible for their content.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImprintModal;